import React from 'react';
import { Trophy, DollarSign, Users } from 'lucide-react';
import CountUp from 'react-countup';

const Glimmer = ({ delay = 0 }) => (
  <div 
    className="glimmer"
    style={{
      left: `${Math.random() * 100}%`,
      animationDelay: `${delay}s`
    }}
  />
);

const Hero = () => {
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="pt-24 pb-16 px-4">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-4xl md:text-6xl font-bold mb-6">
          Register. Wager. <span className="text-[#D7FF00]">Earn.</span>
        </h1>
        <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto">
          Join the most rewarding crypto gambling community. Top players earn weekly rewards up to $35.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-4">
          <div className="relative bg-white/5 p-6 rounded-xl border border-white/10 hover:scale-105 hover:bg-white/10 transition-all duration-300 overflow-hidden">
            {[...Array(5)].map((_, i) => (
              <Glimmer key={i} delay={i * 0.5} />
            ))}
            <Trophy className="w-10 h-10 text-[#D7FF00] mx-auto mb-4" />
            <h3 className="text-2xl font-bold mb-2">
              $<CountUp end={100} duration={2.5} />
            </h3>
            <p className="text-gray-400">Weekly Prizes</p>
          </div>
          
          <div className="relative bg-white/5 p-6 rounded-xl border border-white/10 hover:scale-105 hover:bg-white/10 transition-all duration-300 overflow-hidden">
            {[...Array(5)].map((_, i) => (
              <Glimmer key={i} delay={i * 0.5} />
            ))}
            <DollarSign className="w-10 h-10 text-[#D7FF00] mx-auto mb-4" />
            <h3 className="text-2xl font-bold mb-2">
              $<CountUp end={35} duration={2.5} />
            </h3>
            <p className="text-gray-400">Top Prize</p>
          </div>
          
          <div className="relative bg-white/5 p-6 rounded-xl border border-white/10 hover:scale-105 hover:bg-white/10 transition-all duration-300 overflow-hidden">
            {[...Array(5)].map((_, i) => (
              <Glimmer key={i} delay={i * 0.5} />
            ))}
            <Users className="w-10 h-10 text-[#D7FF00] mx-auto mb-4" />
            <h3 className="text-2xl font-bold mb-2">
              <CountUp end={56} duration={2.5} />+
            </h3>
            <p className="text-gray-400">Active Players</p>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 mb-12">
          <p className="text-gray-400 text-sm">
            Rewards will increase as the total wager volume increases.
          </p>
        </div>
        
        <button 
          onClick={() => scrollToSection('leaderboard-preview')}
          className="glow-button px-8 py-4 rounded-lg text-lg inline-block"
        >
          Join the Competition
        </button>
      </div>
    </div>
  );
};

export default Hero;